import { PrescriptionFilters } from '@state/reducers/prescriptionReducer'
import { axios, getConfigs, IRequestConfig } from './api'
import { PrescriptionDto, ValidatePrescriptionDto } from './dtos'
import { PaginatedDto } from './extendedType'

export class PrescriptionService {
  private static readonly endpoint = 'prescription'

  static getAll(
    query: PrescriptionFilters,
  ): Promise<PaginatedDto<PrescriptionDto>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.endpoint,
        { baseURL: process.env.REACT_APP_RADIOPHARMACY_API_URL }
      )
      configs.params = query
      axios(configs, resolve, reject)
    })
  }

  static validate(id: string, dto: ValidatePrescriptionDto): Promise<PrescriptionDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        `${this.endpoint}/${id}/validate`,
        { baseURL: process.env.REACT_APP_RADIOPHARMACY_API_URL }
      )
      configs.data = dto
      axios(configs, resolve, reject)
    })
  }

  static invalidate(id: string): Promise<PrescriptionDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        `${this.endpoint}/${id}/invalidate`,
        { baseURL: process.env.REACT_APP_RADIOPHARMACY_API_URL }
      )
      axios(configs, resolve, reject)
    })
  }
}
